export default __webpack_public_path__ + "static/media/sidebar5.1ee33015.jpg";